<script xmlns=''>
import Segmented from '@/components/Segmented/Segmented.vue'
import { exportDataToExcel, getUserAttendanceRecord, loadPermissionList, loadUserAttendanceRecord } from '@/api/data'
import moment from 'moment'
import STable from '@/components/Table'
import { getI18nLanguage } from '@/locales'

export default {
  name: 'AttendanceStat',
  components: { Segmented, STable },
  data () {
    return {
      mode: 1,
      columns: [{
        title: this.$t('user.name'),
        align: 'center',
        width: 160,
        dataIndex: 'name',
        fixed: 'left'
      }, {
        title: this.$t('user.org.name'),
        align: 'center',
        width: 160,
        dataIndex: 'org_name'
      }, {
        title: this.$t('user.checkin.work.dur'),
        align: 'center',
        width: 140,
        dataIndex: 'work_dur'
      }, {
        title: this.$t('user.checkin.rest.dur'),
        align: 'center',
        width: 140,
        dataIndex: 'rest_dur'
      }, {
        title: this.$t('user.checkin.work.dur.real'),
        align: 'center',
        width: 140,
        dataIndex: 'real_work_dur'
      },
        {
          title: this.$t('user.checkin.action.clockin'),
          align: 'center',
          children: [
            // {
            //   title: '规定时间',
            //   width: 100,
            //   dataIndex: 'on_rule_time',
            //   align: 'center'
            // },
            {
              title: this.$t('user.checkin.time'),
              width: 100,
              dataIndex: 'on_real_time',
              align: 'center'
            }
          ]
        },
        {
          title: this.$t('user.checkin.action.clockout'),
          align: 'center',
          children: [
            // {
            //   title: '规定时间',
            //   width: 100,
            //   dataIndex: 'out_rule_time',
            //   align: 'center'
            // },
            {
              title: this.$t('user.checkin.time'),
              width: 100,
              dataIndex: 'out_real_time',
              align: 'center'
            }
          ]
        },
        {
          title: this.$t('user.checkin.dur'),
          children: [
            {
              title: '4',
              align: 'center',
              customRender: (value, row, index) => {
                const bars = value.bars
                let mIndex = 0
                const listItems = bars.map((bar) => {
                  const divStyle = {
                    position: 'absolute',
                    overflow: 'hidden',
                    top: mIndex === 0 ? '1px' : 0,
                    'z-index': 100 + mIndex,
                    left: bar.left,
                    right: bar.right,
                    height: '32px',
                    'background-color': bar.color
                  }
                  mIndex++
                  const title = bar.title
                  return <div style={divStyle} title={title}></div>
                })
                const obj = {
                  style: { padding: 0, margin: 0 },
                  children:
                    <div style='position:relative;width:100%;height:32px;overflow:hidden;padding:0;'>
                      {listItems}
                    </div>,
                  attrs: {
                    colSpan: 24
                  }
                }
                return obj
              }
            },
            {
              title: '5',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '6',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '7',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '8',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '9',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '10',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '11',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '12',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '13',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '14',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '15',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '16',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '17',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '18',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '19',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '20',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '21',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '22',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '23',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '0',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '1',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '2',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            },
            {
              title: '3',
              align: 'center',
              customRender: (value, row, index) => {
                const obj = {
                  children: value,
                  attrs: {
                    colSpan: 0
                  }
                }
                return obj
              }
            }
          ]
        }
        // {
        //   title: '备注',
        //   align: 'center',
        //   width: 160,
        //   dataIndex: 'remark',
        //   fixed: 'right'
        // }, {
        //   title: '操作',
        //   align: 'center',
        //   width: 160,
        //   dataIndex: 'action',
        //   fixed: 'right'
        // }
      ],
      queryParams: { type: 1, date: moment().format('YYYY-MM-DD') },
      data: [],
      driverInfoMap: {},
      loading: false,
      options: [{
        label: this.$t('user.checkin.stat.single.day'),
        value: 1
      }, { label: this.$t('user.checkin.stat.more.day'), value: 2 }],
      columns3: [{
        title: this.$t('user.name'),
        align: 'center',
        dataIndex: 'name'
      }, {
        title: this.$t('user.org.name'),
        align: 'center',
        dataIndex: 'org_name'
      }, {
        title: this.$t('user.account'),
        align: 'center',
        dataIndex: 'account'
      }, {
        title: this.$t('user.checkin.action'),
        scopedSlots: { customRender: 'action' },
        align: 'center',
        dataIndex: 'type'
      }, {
        title: this.$t('user.checkin.date'),
        align: 'center',
        dataIndex: 'sign_date'
      }, {
        title: this.$t('user.checkin.time'),
        align: 'center',
        scopedSlots: { customRender: 'sign_time' },
        dataIndex: 'sign_time'
      }, {
        title: this.$t('user.checkin.location'),
        align: 'center',
        scopedSlots: { customRender: 'location' },
        dataIndex: 'sign_time'
      }],
      queryParams3: {
        uid: null,
        date: null,
        type: null
      },
      queryParams2: {
        month: moment()
      },
      // 数据卡改用骨架的 12px 上下内边距（原来是 4px 0），表体可用高度跟着扣 16
      height: document.body.clientHeight - 306,
      width: document.body.clientWidth,
      alertMessage: null,
      cDriver: null,
      loadData3: (paramter) => {
        const q = Object.assign({}, this.queryParams3)
        if (q.date) {
          q.date = q.date.format('YYYY-MM-DD')
        }
        return getUserAttendanceRecord(Object.assign(paramter, q)).then(res => {
          var data = res.result.data
          for (const item of data) {
            if (this.driverInfoMap[item.uid]) {
              item.name = this.driverInfoMap[item.uid].name
              item.account = this.driverInfoMap[item.uid].account
            } else {
              item.name = item.user_name
              item.account = item.user_account
            }
          }
          return res.result
        })
      },
      data3: [],
      proDrivers: [],
      drivers: []
    }
  },
  created () {
    loadPermissionList({ pageNo: 1, pageSize: 100 }).then(res => {
      const ds = res.result.data
      this.drivers = ds
      const users = []
      const proUsers = []
      let expireNum = 0
      const proDrivers = []
      const driverInfoMap = {}
      for (const item of ds) {
        if (item.user_level > 0 && moment(item.level_expire).isAfter(moment())) {
          proUsers.push(item.user_id)
          driverInfoMap[item.user_id] = {
            name: item.name,
            account: item.account
          }
          proDrivers.push(item)
        } else {
          expireNum++
        }
        users.push(item.user_id)
      }
      this.proDrivers = proDrivers
      if (proUsers.length > 0) {
        this.queryParams2.uid = proUsers[0]
      }
      if (expireNum > 0) {
        this.alertMessage = this.$t('user.checkin.stat.expire.tip').replace('{num}', expireNum)
      }

      this.driverInfoMap = driverInfoMap
      this.queryParams.uid = proUsers
      this.queryParams3.users = users
      this.loadData()
    })
  },
  methods: {
    getI18nLanguage,
    moment,
    loadData () {
      this.data = []
      this.loading = true
      if (this.mode === 1) {
        loadUserAttendanceRecord(this.queryParams).then(res => {
          const records = res.data
          const dRecord = {}
          for (const item of records) {
            if (!dRecord[item.uid]) {
              dRecord[item.uid] = {
                breakStart: false,
                breakTmp: [],
                breaks: [],
                org_name: item.org_name
              }
            }
            switch (item.type) {
              case 1:
                if (!dRecord[item.uid].on_real_time) {
                  dRecord[item.uid].on_real_time = moment(item.sign_time).format('HH:mm')
                  dRecord[item.uid].work_start_time = item.sign_time
                }
                break
              case 2:
                dRecord[item.uid].out_real_time = moment(item.sign_time).format('HH:mm')
                dRecord[item.uid].work_end_time = item.sign_time
                if (dRecord[item.uid].breakStart) {
                  // 开始休息但未结束休息直接下班
                  dRecord[item.uid].breakTmp.push(item.sign_time)
                  dRecord[item.uid].breaks.push(dRecord[item.uid].breakTmp)
                }
                break
              case 3:
                if (!dRecord[item.uid].breakStart) {
                  dRecord[item.uid].breakStart = true
                  dRecord[item.uid].breakTmp.push(item.sign_time)
                }

                break
              case 4:
                if (!dRecord[item.uid].breakStart) {
                  // extend into the next day
                  dRecord[item.uid].breakTmp.push(moment(this.queryParams.date + ' 00:00:00').valueOf())
                  dRecord[item.uid].breakTmp.push(item.sign_time)
                  dRecord[item.uid].breaks.push(dRecord[item.uid].breakTmp)
                } else {
                  dRecord[item.uid].breakTmp.push(item.sign_time)
                  dRecord[item.uid].breaks.push(dRecord[item.uid].breakTmp)
                }
                dRecord[item.uid].breakTmp = []
                dRecord[item.uid].breakStart = false
                break
            }
          }
          const ds = Object.keys(this.driverInfoMap)
          const data = []
          // eslint-disable-next-line camelcase
          let work_dur = 0
          // eslint-disable-next-line camelcase
          let restDur = 0
          for (const d of ds) {
            const bars = []
            const name = this.driverInfoMap[d].name
            if (dRecord[d]) {
              if ((!dRecord[d].work_start_time) && dRecord[d].work_end_time) {
                dRecord[d].work_start_time = moment(this.queryParams.date + ' 00:00:00').valueOf()
              }
              if ((dRecord[d].work_start_time) && (!dRecord[d].work_end_time)) {
                if (this.queryParams.date === moment().format('YYYY-MM-DD')) {
                  dRecord[d].work_end_time = moment().valueOf()
                } else {
                  dRecord[d].work_end_time = moment(this.queryParams.date + ' 23:59:59').valueOf()
                }
              }
              // eslint-disable-next-line camelcase
              work_dur = ((dRecord[d].work_end_time - dRecord[d].work_start_time) / 3600000).toFixed(2)
              const dayStart = moment(this.queryParams.date + ' 04:00:00').valueOf()
              const dayEnd = moment(this.queryParams.date + ' 00:00:00').add(1, 'days').valueOf()
              if (dRecord[d].work_start_time < dayStart) {
                if (dRecord[d].work_end_time > dayStart) {
                  // 4->end
                  bars.push({
                    left: '0%',
                    right: (4 * 3600000 - dRecord[d].work_end_time + dayEnd) * 100 / (24 * 3600000) + '%',
                    color: '#00CC33',
                    title: '04:00~' + moment(dRecord[d].work_end_time).format('HH:mm') + ' ' + this.$t('user.attendance.work')
                  })
                }
                // start->(end<4?end:4)
                bars.push({
                  left: ((dRecord[d].work_start_time + 24 * 3600000 - dayStart) * 100 / (24 * 3600000) + '%'),
                  right: dRecord[d].work_end_time >= dayStart ? 0 : ((dayStart - dRecord[d].work_end_time) * 100 / (24 * 3600000) + '%'),
                  color: '#00CC33',
                  title: moment(dRecord[d].work_start_time).format('HH:mm') + '~' + (dRecord[d].work_end_time >= dayStart ? '04:00' : moment(dRecord[d].work_end_time)) + ' ' + this.$t('user.attendance.work')
                })
              } else {
                bars.push({
                  left: (dRecord[d].work_start_time - dayStart) * 100 / (24 * 3600000) + '%',
                  right: (4 * 3600000 - dRecord[d].work_end_time + dayEnd) * 100 / (24 * 3600000) + '%',
                  color: '#00CC33',
                  title: moment(dRecord[d].work_start_time).format('HH:mm') + '~' + moment(dRecord[d].work_end_time).format('HH:mm') + ' ' + this.$t('user.attendance.work')
                })
              }
              const breaks = dRecord[d].breaks
              if (breaks && breaks.length > 0) {
                for (const b of breaks) {
                  // eslint-disable-next-line camelcase
                  const df = b[1] - b[0]
                  restDur = restDur + df
                  bars.push({
                    left: (b[0] - dayStart) * 100 / (24 * 3600000) + '%',
                    right: (4 * 3600000 - b[1] + dayEnd) * 100 / (24 * 3600000) + '%',
                    color: '#FFCC00',
                    title: moment(b[0]).format('HH:mm') + '~' + moment(b[1]).format('HH:mm') + ' ' + this.$t('user.attendance.rest')
                  })
                }
              }
            }
            // eslint-disable-next-line camelcase
            restDur = restDur / 3600000
            data.push({
              name: name,
              org_name: dRecord[d] ? dRecord[d].org_name : null,
              on_real_time: dRecord[d] ? dRecord[d].on_real_time : null,
              out_real_time: dRecord[d] ? dRecord[d].out_real_time : null,
              bars: bars,
              work_dur: work_dur,
              rest_dur: restDur.toFixed(2),
              // eslint-disable-next-line camelcase
              real_work_dur: (work_dur - restDur).toFixed(2)
            })
          }
          this.data = data
          this.loading = false
        })
      } else if (this.mode === 2) {
        loadUserAttendanceRecord({
          month: this.queryParams2.month.format('YYYY-MM'),
          uid: this.queryParams2.uid
        }).then(res => {
          const records = res.data
          const dMap = {}
          for (const item of records) {
            const date = moment(item.sign_time).format('YYYY-MM-DD')
            if (!dMap[date]) {
              dMap[date] = []
            }
            dMap[date].push(item)
          }
          const data = []
          const mMonth = this.queryParams2.month.format('YYYY-MM')
          const startMoment = this.queryParams2.month.format(mMonth + '-01 00:00:00')

          for (let i = 1; i <= 31; i++) {
            const date = moment(startMoment).add(i - 1, 'days').format('YYYY-MM-DD')

            if (date.startsWith(mMonth)) {
              if (dMap[date]) {
                const dayStat = this.calcDayAttendanceStat(dMap[date], date)
                data.push(Object.assign({
                  stat_date: date
                }, dayStat))
              } else {
                data.push({
                  stat_date: date,
                  bars: []
                })
              }
            }
          }
          this.data = data
          this.loading = false
        })
      }
    },
    calcDayAttendanceStat (records, date) {
      const dRecord = {
        breakStart: false,
        breakTmp: [],
        breaks: []
      }
      for (const item of records) {
        switch (item.type) {
          case 1:
            if (!dRecord.on_real_time) {
              dRecord.on_real_time = moment(item.sign_time).format('HH:mm')
              dRecord.work_start_time = item.sign_time
            }
            break
          case 2:
            dRecord.out_real_time = moment(item.sign_time).format('HH:mm')
            dRecord.work_end_time = item.sign_time
            if (dRecord.breakStart) {
              // 开始休息但未结束休息直接下班
              dRecord.breakTmp.push(item.sign_time)
              dRecord.breaks.push(dRecord.breakTmp)
            }
            break
          case 3:
            if (!dRecord.breakStart) {
              dRecord.breakStart = true
              dRecord.breakTmp.push(item.sign_time)
            }

            break
          case 4:
            if (!dRecord.breakStart) {
              // extend into the next day
              dRecord.breakTmp.push(moment(date + ' 00:00:00').valueOf())
              dRecord.breakTmp.push(item.sign_time)
              dRecord.breaks.push(dRecord.breakTmp)
            } else {
              dRecord.breakTmp.push(item.sign_time)
              dRecord.breaks.push(dRecord.breakTmp)
            }
            dRecord.breakTmp = []
            dRecord.breakStart = false
            break
        }
      }

      // eslint-disable-next-line camelcase
      let work_dur = 0
      // eslint-disable-next-line camelcase
      let restDur = 0

      const bars = []

      if ((!dRecord.work_start_time) && dRecord.work_end_time) {
        dRecord.work_start_time = moment(date + ' 00:00:00').valueOf()
      }
      if ((dRecord.work_start_time) && (!dRecord.work_end_time)) {
        if (date === moment().format('YYYY-MM-DD')) {
          dRecord.work_end_time = moment().valueOf()
        } else {
          dRecord.work_end_time = moment(date + ' 23:59:59').valueOf()
        }
      }
      // eslint-disable-next-line camelcase
      work_dur = ((dRecord.work_end_time - dRecord.work_start_time) / 3600000).toFixed(2)
      const dayStart = moment(date + ' 04:00:00').valueOf()
      const dayEnd = moment(date + ' 00:00:00').add(1, 'days').valueOf()
      if (dRecord.work_start_time < dayStart) {
        if (dRecord.work_end_time > dayStart) {
          // 4->end
          bars.push({
            left: '0%',
            right: (4 * 3600000 - dRecord.work_end_time + dayEnd) * 100 / (24 * 3600000) + '%',
            color: '#00CC33',
            title: '04:00~' + moment(dRecord.work_end_time).format('HH:mm') + ' ' + this.$t('user.attendance.work')
          })
        }
        // start->(end<4?end:4)
        bars.push({
          left: ((dRecord.work_start_time + 24 * 3600000 - dayStart) * 100 / (24 * 3600000) + '%'),
          right: dRecord.work_end_time >= dayStart ? 0 : ((dayStart - dRecord.work_end_time) * 100 / (24 * 3600000) + '%'),
          color: '#00CC33',
          title: moment(dRecord.work_start_time).format('HH:mm') + '~' + (dRecord.work_end_time >= dayStart ? '04:00' : moment(dRecord.work_end_time)) + ' ' + this.$t('user.attendance.work')
        })
      } else {
        bars.push({
          left: (dRecord.work_start_time - dayStart) * 100 / (24 * 3600000) + '%',
          right: (4 * 3600000 - dRecord.work_end_time + dayEnd) * 100 / (24 * 3600000) + '%',
          color: '#00CC33',
          title: moment(dRecord.work_start_time).format('HH:mm') + '~' + moment(dRecord.work_end_time).format('HH:mm') + ' ' + this.$t('user.attendance.work')
        })
      }
      const breaks = dRecord.breaks
      if (breaks && breaks.length > 0) {
        for (const b of breaks) {
          // eslint-disable-next-line camelcase
          const df = b[1] - b[0]
          restDur = restDur + df
          bars.push({
            left: (b[0] - dayStart) * 100 / (24 * 3600000) + '%',
            right: (4 * 3600000 - b[1] + dayEnd) * 100 / (24 * 3600000) + '%',
            color: '#FFCC00',
            title: moment(b[0]).format('HH:mm') + '~' + moment(b[1]).format('HH:mm') + ' ' + this.$t('user.attendance.rest')
          })
        }
      }

      // eslint-disable-next-line camelcase
      restDur = restDur / 3600000
      return {
        on_real_time: dRecord ? dRecord.on_real_time : null,
        out_real_time: dRecord ? dRecord.out_real_time : null,
        bars: bars,
        work_dur: work_dur,
        rest_dur: restDur.toFixed(2),
        // eslint-disable-next-line camelcase
        real_work_dur: (work_dur - restDur).toFixed(2)
      }
    },
    handleModeChange (e) {
      this.mode = e
      switch (e) {
        case 1:
          this.columns.splice(0, 1, {
            title: this.$t('user.name'),
            align: 'center',
            width: 160,
            dataIndex: 'name',
            fixed: 'left'
          })

          break
        case 2:
          this.columns.splice(0, 1, {
            title: this.$t('user.checkin.stat.date'),
            align: 'center',
            width: 160,
            dataIndex: 'stat_date',
            fixed: 'left'
          })
          break
      }
      this.loadData()
    },
    handleChangeDate (e) {
      this.queryParams.date = e.format('YYYY-MM-DD')
      this.loadData()
    },
    handleChangeMonth (e) {
      this.queryParams2.month = e
      this.loadData()
    },
    handleChangeDriver (e) {
      this.queryParams2.uid = e
      this.loadData()
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    refreshTable3 () {
      this.$refs.table3.refresh()
    },
    actionLabel (type) {
      switch (Number(type)) {
        case 1: return this.$t('user.checkin.action.clockin')
        case 2: return this.$t('user.checkin.action.clockout')
        case 3: return this.$t('user.checkin.action.breakstart')
        case 4: return this.$t('user.checkin.action.breakend')
        default: return ''
      }
    },
    // 按当前筛选条件拉全部考勤记录（不只当前页），交给通用导出接口生成 xlsx；表头用 $t 本地化
    async exportRecords () {
      const q = Object.assign({}, this.queryParams3)
      if (q.date) {
        q.date = q.date.format('YYYY-MM-DD')
      }
      q.pageNo = 1
      q.pageSize = 100000
      const hide = this.$message.loading(this.$t('user.excel.exporting'), 0)
      const fileName = this.$t('user.checkin.export.filename') + '.xlsx'
      try {
        const res = await getUserAttendanceRecord(q)
        const rows = (res && res.result && res.result.data) || []
        if (rows.length === 0) {
          this.$message.warning(this.$t('user.checkin.export.fail'))
          return
        }
        const data = rows.map(item => {
          const info = this.driverInfoMap[item.uid]
          return {
            name: info ? info.name : item.user_name,
            org_name: item.org_name,
            account: info ? info.account : item.user_account,
            action: this.actionLabel(item.type),
            sign_date: item.sign_date,
            sign_time: moment(item.sign_time).format('HH:mm:ss'),
            location: item.loc_str || ''
          }
        })
        const resp = await exportDataToExcel({
          fileName: fileName,
          sheets: [{
            title: this.$t('user.checkin.record'),
            columns: [
              { title: this.$t('user.name'), dataIndex: 'name', width: 18 },
              { title: this.$t('user.org.name'), dataIndex: 'org_name', width: 20 },
              { title: this.$t('user.account'), dataIndex: 'account', width: 22 },
              { title: this.$t('user.checkin.action'), dataIndex: 'action', width: 14 },
              { title: this.$t('user.checkin.date'), dataIndex: 'sign_date', width: 15 },
              { title: this.$t('user.checkin.time'), dataIndex: 'sign_time', width: 13 },
              { title: this.$t('user.checkin.location'), dataIndex: 'location', width: 30 }
            ],
            data: data
          }]
        })
        this.saveResultAsExcel(resp, fileName)
      } catch (e) {
        this.$message.error(this.$t('user.checkin.export.fail'))
      } finally {
        hide()
      }
    }
  }
}
</script>

<template>
  <div class="attendance-page">
    <a-tabs>
      <a-tab-pane :key="1" :tab="$t('user.checkin.stat')">
        <div class="stat-controls">
          <a-alert
            v-if="alertMessage"
            class="stat-controls__alert"
            :message="alertMessage"
            show-icon
            banner
            closable />
          <div class="stat-controls__row">
            <div class="stat-controls__left">
              <segmented :itemWidth="140" :options="options" @change="handleModeChange"></segmented>
              <div v-if="mode === 1" class="stat-controls__field">
                <label class="stat-controls__label">{{ $t('user.checkin.stat.date') }}</label>
                <a-date-picker v-model="queryParams.date" @change="handleChangeDate" />
              </div>
              <template v-if="mode === 2">
                <div class="stat-controls__field">
                  <label class="stat-controls__label">{{ $t('user.checkin.stat.month') }}</label>
                  <a-month-picker
                    v-model="queryParams2.month"
                    style="width: 130px;"
                    @change="handleChangeMonth" />
                </div>
                <div class="stat-controls__field">
                  <label class="stat-controls__label">{{ $t('user.checkin.driver') }}</label>
                  <a-select v-model="queryParams2.uid" style="width: 160px;" @change="handleChangeDriver">
                    <a-select-option v-for="driver in proDrivers" :key="driver.user_id" :value="driver.user_id">
                      {{ driver.name }}
                    </a-select-option>
                  </a-select>
                </div>
              </template>
            </div>
            <div class="stat-controls__legend" v-if="width >= 1000">
              <span class="legend-item">
                <span class="legend-item__swatch" style="background: #52C41A;"></span>
                {{ $t('user.attendance.work.dur') }}
              </span>
              <span class="legend-item">
                <span class="legend-item__swatch" style="background: #FAAD14;"></span>
                {{ $t('user.attendance.rest.dur') }}
              </span>
            </div>
          </div>
        </div>
        <div class="table-card">
          <a-table
            :columns="columns"
            :data-source="data"
            :loading="loading"
            :pagination="false"
            :scroll="{ x: 1600, y: height }"
            bordered
            size="small">
          </a-table>
        </div>
      </a-tab-pane>

      <a-tab-pane :key="2" :tab="$t('user.checkin.record')">
        <div class="filter-card">
          <div class="filter-card__body">
            <a-row :gutter="16">
              <a-col :span="5">
                <div class="filter-item">
                  <label class="filter-item__label">{{ $t('user.name') }}</label>
                  <a-select
                    v-model="queryParams3.uid"
                    :filter-option="filterOption"
                    allowClear
                    option-filter-prop="children"
                    show-search
                    class="filter-item__input">
                    <a-select-option v-for="driver in drivers" :key="driver.user_id" :value="driver.user_id">
                      {{ driver.name }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-col>
              <a-col :span="5">
                <div class="filter-item">
                  <label class="filter-item__label">{{ $t('user.checkin.date') }}</label>
                  <a-date-picker v-model="queryParams3.date" class="filter-item__input" />
                </div>
              </a-col>
              <a-col :span="5">
                <div class="filter-item">
                  <label class="filter-item__label">{{ $t('user.checkin.action') }}</label>
                  <a-select v-model="queryParams3.type" allowClear class="filter-item__input">
                    <a-select-option :value="1">{{ $t('user.checkin.action.clockin') }}</a-select-option>
                    <a-select-option :value="2">{{ $t('user.checkin.action.clockout') }}</a-select-option>
                    <a-select-option :value="3">{{ $t('user.checkin.action.breakstart') }}</a-select-option>
                    <a-select-option :value="4">{{ $t('user.checkin.action.breakend') }}</a-select-option>
                  </a-select>
                </div>
              </a-col>
              <a-col :span="9">
                <div class="filter-item filter-item--actions">
                  <a-button type="primary" @click="refreshTable3">{{ $t('user.action.search') }}</a-button>
                  <a-button icon="export" style="margin-left: 8px;" @click="exportRecords">{{ $t('user.checkin.export') }}</a-button>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
        <div class="table-card">
          <s-table
            ref="table3"
            :columns="columns3"
            :data="loadData3"
            :loading="loading"
            bordered
            size="small">
            <span
              slot="sign_time"
              slot-scope="text, record"
              class="cell-time">{{ moment(record.sign_time).format('HH:mm:ss') }}</span>
            <span slot="location" slot-scope="text, record">
              <a
                class="location-link"
                :href="'https://www.google.com/maps/place/' + record.loc_gl"
                target="_blank">
                <a-icon type="environment" />
                {{ record.loc_str }}
              </a>
            </span>
            <div slot="action" slot-scope="text, record">
              <span v-if="record.type == 1" class="action-type action-type--clockin">{{ $t('user.checkin.action.clockin') }}</span>
              <span v-if="record.type == 2" class="action-type action-type--clockout">{{ $t('user.checkin.action.clockout') }}</span>
              <span v-if="record.type == 3" class="action-type action-type--break">{{ $t('user.checkin.action.breakstart') }}</span>
              <span v-if="record.type == 4" class="action-type action-type--break">{{ $t('user.checkin.action.breakend') }}</span>
            </div>
          </s-table>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<style lang="less" scoped>
// 列表页骨架（筛选条 + 数据卡），见 assets/list-page.less
@import '../../assets/list-page.less';

@primary: #0A76C6;
@border-color: #dce5ee;
@text-primary: #101b25;
@text-secondary: #5b6b7b;
@radius: 6px;
@shadow-card: 0 1px 2px rgba(16, 32, 48, 0.06), 0 1px 3px rgba(16, 32, 48, 0.04);
@transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);

.attendance-page {
  background: transparent;
}

/* ── Stats controls ── */
.stat-controls {
  padding: 0 16px;

  &__alert {
    margin-bottom: 12px;
    border-radius: @radius;
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 12px;
  }

  &__left {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  &__field {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__label {
    font-size: 13px;
    color: @text-secondary;
    white-space: nowrap;
  }

  &__legend {
    display: flex;
    align-items: center;
    gap: 20px;
  }
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: @text-secondary;

  &__swatch {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 3px;
  }
}

/* ── 卡片位置 ── */
// 页签内容本身没有左右内边距：两张卡各自缩 16px，和上面的 .stat-controls 对齐
// （内边距、底色、投影用骨架的，这里只管外边距）
.filter-card,
.table-card {
  margin-right: 16px;
  margin-left: 16px;
}

// 日次統計页的卡上面是 .stat-controls（不是骨架认的卡片类），
// 所以这一张得自己顶出 12px；打卡记录页里它和骨架给的是同一个值
.table-card {
  margin-top: 12px;
}

/* ── 单元格 ── */
.cell-time {
  font-family: var(--font-data);
  font-size: 12px;
  color: var(--ink-2);
}

/* ── 打卡动作徽标 ── */
.action-type {
  .badge-base();

  &--clockin {
    color: var(--pass-ink);
    background: var(--pass-tint);
  }

  &--clockout {
    color: var(--brand-dark);
    background: var(--brand-tint);
  }

  &--break {
    color: var(--warn-ink);
    background: var(--warn-tint);
  }
}

@media (max-width: 768px) {
  .stat-controls__row {
    flex-direction: column;
    align-items: flex-start;
  }

  .stat-controls__legend {
    margin-top: 8px;
  }

  .filter-card {
    margin: 0 8px 12px;
  }
}
</style>

<style>
.ant-tabs-bar {
  margin: 0 0 8px 0;
}
</style>
